import {useState} from "react";
import {postErrorLog, postRatingForm, postUserForm, postWebhook} from "../api";
import useSip from "./Sip";
import useRingtone from "./Ringtone";
import {useTranslation} from "react-i18next";

const useCallService = ({linkData, statistic, audio, updateData}) => {
    const {t} = useTranslation();
    const [calling, setCalling] = useState(false);
    const [muted, setMuted] = useState(false);
    const [answer, setAnswer] = useState(false);
    const [view, setView] = useState('first');
    const [playAudio, stopAudio] = useRingtone('/mp3/tone.mp3');
    const sip = useSip(audio);
    const checkAndChangeRender = () => {
        linkData.enable_call_rating ? setView('second') : setView('end');
    };

    sip.delegate = {
        onCallCreated: () => {
            console.log('call created')
            let promise = playAudio();
            if (promise !== undefined) promise.catch(e => e.toString());
        },
        onCallAnswered: () => {
            console.log('call answered')
            stopAudio();
            setAnswer(true);
        },
        onCallHangup: () => {
            console.log('call hanguped');
            stopAudio();
            checkAndChangeRender();
        }
    }
    const [contactForm, setContactForm] = useState({
        user_name: null,
        user_phone: null,
    });
    const [ratingForm, setRatingForm] = useState({
        call_rating: 0,
        user_comment: '',
    });
    const mute = () => {
        if (sip.isMuted()) {
            sip.unmute();
            setMuted(false);
        } else {
            sip.mute();
            setMuted(true);
        }
    };
    const hangUp = async () => {
        let session = sip.session;
        if (typeof session !== 'undefined' && (session.state === 'Establishing' || session.state === 'Established')) {
            console.log('end call');
            await sip.hangup();
            checkAndChangeRender();
        }
    };
    const sendDtmf = number => {
        sip.sendDTMF(number).then();
    };
    const paramsToExtraHeaders = () => {
        const queryString = window.location.href.split('?')[1] || '';

        return queryString
            .split('&')
            .map(param => {
                const [key, value] = param.split('=');
                return `${key}: ${value}`;
            })
            .filter(header => header.includes('x-header-'))
            .map(header => header.replace('x-header-', 'X-'));
    };
    const call = (target, headers = null, webHookData) => {
        console.log('start call!')
        let errMessage = t('serverError');
        postWebhook(webHookData);
        setCalling(true);
        const destination = `sip:${target}@${process.env.REACT_APP_WSS_URL}`;
        sip.connect()
            .then(() => sip.call(destination, headers))
            .catch((error) => {
                let params = statistic;
                params.append('message', error);
                params.append('follow_log_id', linkData['follow_log_id']);
                postErrorLog(params);
                if (error.name === 'NotAllowedError')
                    errMessage = t('notAllowedError');
                if (error.name === 'NotFoundError')
                    errMessage = t('headPhoneError');
                updateData(null, 'error', errMessage);
            });
    }
    const contactHandler = (event) => {
        let nam = event.target.name,
            val = event.target.value;
        setContactForm({...contactForm, [nam]: val});
    };
    const commentHandler = (event) => {
        let nam = event.target.name,
            val = event.target.value;
        setRatingForm({...ratingForm, [nam]: val});
    };
    const changeRating = (newRating, name) => {
        setRatingForm({...ratingForm, [name]: newRating});
    };
    const yaClientId = () => {
        let match = document.cookie.match('(?:^|;)\\s*_ym_uid=([^;]*)');
        return (match) ? decodeURIComponent(match[1]) : false;
    }
    const callHeaders = (session_id) => (
        {
            extraHeaders:
                [
                    `X-client-type: 3b27fc8bfd3f6839314f17e79e3bda1c`,
                    `X-Follow-Log-Id: ${linkData['follow_log_id']}`,
                    `X-Session-Id: ${session_id}`,
                    `X-Ya-Client-Id: ${yaClientId()}`,
                    ...paramsToExtraHeaders()
                ]
        });

    const buildRatingForm = () => {
        if (ratingForm.call_rating) {
            ratingForm.session_id = statistic.get('session_id');
            ratingForm.follow_log_id = linkData['follow_log_id'];
            let params = new URLSearchParams(ratingForm).toString();
            postRatingForm(params);
            setView('end');
        }
    };
    const buildUserForm = () => {
        if (contactForm.user_name && contactForm.user_phone) {
            contactForm.session_id = statistic.get('session_id');
            contactForm.follow_log_id = linkData['follow_log_id'];
            let params = new URLSearchParams(contactForm);
            params.set('user_phone', contactForm.user_phone.toString().replace(/\D/g, ''));
            postUserForm(params.toString());
        }
        call(linkData['link_code'], callHeaders(statistic.get('session_id')), statistic);
    };

    return {
        view,
        ratingForm,
        call,
        mute,
        muted,
        hangUp,
        sendDtmf,
        contactHandler,
        commentHandler,
        changeRating,
        calling,
        answer,
        buildRatingForm,
        buildUserForm,
        paramsToExtraHeaders,
        yaClientId
    };
};

export default useCallService;
